export default __webpack_public_path__ + "static/media/6.9639b3e1.webp";